import React, { useState } from 'react';
import { styled } from '@glitz/react';
import VideoSourceType from 'Shared/ViewModels/VideoSourceViewModel.type';
import Video from 'Shared/Video/Video';
import { H2, ResponsiveSize, TextLabel } from 'Shared/SharedComponents/atoms/Typography';
import { ButtonHeight, ButtonTheme, SolidButton } from 'Shared/TextButtons';
import { Play12x12 } from 'Shared/Icons/Play';
import * as style from 'Shared/Style';

type PropType = {
  videoSources: VideoSourceType[];
  previewImage: Scope.UrlViewModel;
  playButtonText: string;
  label: string;
  heading: string;
  isCompact: boolean;
};

const ContentWrap = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'end',
  height: '100%',
  textAlign: 'center',
})

const ButtonWrap = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'end',
  height: '100%',
  paddingBottom: '12px',
  ['@media ' + style.mediaMinLarge]: {
    paddingBottom: '16px',
  },        
})

const Label = styled(TextLabel, {
  marginBottom: '16px'
})

const Center = styled.div({
  textAlign: 'center',
})

const ButtonIcon = styled(Play12x12, {
  marginLeft: '8px'
})

const VideoContent = ({ videoSources, previewImage, label, heading, playButtonText, isCompact }: PropType) => {
  const [videoStarted, setVideoStarted] = useState(false);

  return (
    <Video
      videoSources={videoSources}
      previewImage={previewImage}
      isCompact={isCompact}
      videoStarted={videoStarted}
      stopVideo={() => setVideoStarted(false)}
    >
      <ContentWrap>
        {label && <Label fontSize={ResponsiveSize.D14_M12}>{label}</Label>}
        {heading && <H2 fontSize={ResponsiveSize.D32_M20}>{heading}</H2>}
      </ContentWrap>
      <ButtonWrap>
        <Center>
          <SolidButton
            text={playButtonText}
            onClick={() => setVideoStarted(true)}
            theme={ButtonTheme.WhiteBorderToBlack}
            iconAfter={<ButtonIcon />}
            height={ButtonHeight.Big}
          />
        </Center>
      </ButtonWrap>
    </Video>
  );
};

export default VideoContent;
